// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"199":"8ec52c76","964":"22916cf5"}[chunkId] + ".chunk.js";
};